var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { ThemeBreakpointObserver } from '@inter-ikea-kompis/themes';
import { CarouselItem, CarouselLayoutEnum } from '@inter-ikea-kompis/component-carousel';
import { Carousel } from '@inter-ikea-kompis/component-carousel';
import { FocusOutlinePositionWatcherEnum } from '@inter-ikea-kompis/component-focus-outline';
import PillAlignEnum from '../../enums/PillAlignEnum.js';
import PillSizeOptionsEnum from '../../enums/PillSizeOptionsEnum.js';
import Pill from '../pill/Pill.js';
import PillGroupCarouselStyle from './PillGroupCarouselStyle.js';
/**
 * Product Gallery View component.
 *
 * @event change Event forwarded from kompis-carousel
 * @event select A select event is triggered when pill is selected
 */
export default class PillGroupCarousel extends KompisElement {
    constructor() {
        super(...arguments);
        // Visibility of navigation arrows
        this.showArrows = false;
        // Array of MediaItem objects
        this.pillItems = null;
        // Align the icon 'right' or 'left'.
        this.alignIcon = PillAlignEnum.left;
        // Thumbnail
        this.thumbnail = null;
        // Pill size option
        this.pillSize = PillSizeOptionsEnum.medium;
        // Set which slide index that should be active
        this.selectedIndex = 0;
        // Label for the Carousel to set as an aria-label for accessibility reasons
        this.ariaLabelCarousel = null;
        // Role description for the Carousel to set as an aria-roledescription for accessibility reasons
        this.ariaRoleDescriptionCarousel = null;
        // Label for the CarouselControl LeftArrow to set as an aria-label for accessibility reasons
        this.ariaLabelCarouselLeftArrow = null;
        // Label for the CarouselControl RightArrow to set as an aria-label for accessibility reasons
        this.ariaLabelCarouselRightArrow = null;
        this.breakpointObserver = new ThemeBreakpointObserver(() => this.requestUpdate());
    }
    /**
     * Renders the component.
     *
     * @returns Template.
     */
    render() {
        return html `
			<style>
				${PillGroupCarouselStyle.getStyle({
            theme: this.theme
        })}
			</style>
			<kompis-carousel
				.theme="${this.theme}"
				.showArrows="${this.showArrows}"
				.pillSize="${this.pillSize}"
				.alignIcon="${this.alignIcon}"
				.layout="${CarouselLayoutEnum.overflow}"
				.thumbnail="${this.thumbnail}"
				.slideVisibleItems="${true}"
				.pointerSwipe="${true}"
				.selectedIndex="${this.selectedIndex}"
				.ariaLabel="${this.ariaLabelCarousel || ''}"
				.ariaRoleDescription="${this.ariaRoleDescriptionCarousel || ''}"
				.ariaLabelCarouselControlsLeftArrow="${this.ariaLabelCarouselLeftArrow || ''}"
				.ariaLabelCarouselControlsRightArrow="${this.ariaLabelCarouselRightArrow || ''}"
				@change="${(event) => this.dispatchEvent(new CustomEvent('change', {
            bubbles: true,
            detail: { selectedIndex: event.detail.selectedIndex }
        }))}"
			>
				${this.getPills()}
			</kompis-carousel>
		`;
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.breakpointObserver.disconnect();
    }
    connectedCallback() {
        this.customElements.define('kompis-carousel', Carousel);
        this.customElements.define('kompis-carousel-item', CarouselItem);
        this.customElements.define('kompis-pill', Pill);
        super.connectedCallback();
    }
    shouldUpdate(changedProperties) {
        if (changedProperties.has('theme')) {
            this.breakpointObserver.observe(this.theme);
        }
        return true;
    }
    /**
     * Returns carousel items.
     *
     * @returns Carousel items.
     */
    getPills() {
        if (!this.pillItems) {
            return null;
        }
        return this.pillItems?.map((pillItem, index) => html `
				<kompis-carousel-item .theme="${this.theme}">
					<kompis-pill
						@select="${() => this.dispatchEvent(new CustomEvent('select', { bubbles: true, detail: { selectedIndex: index } }))}"
						.focusOutlinePositionWatcher="${FocusOutlinePositionWatcherEnum.enabled}"
						.pillSize="${this.pillSize}"
						.alignIcon="${this.alignIcon}"
						.thumbnail="${this.thumbnail}"
						.icon="${pillItem.icon || null}"
						.theme="${this.theme}"
						.label="${pillItem.name}"
					></kompis-pill>
				</kompis-carousel-item>
			`);
    }
}
__decorate([
    property({ type: Boolean })
], PillGroupCarousel.prototype, "showArrows", void 0);
__decorate([
    property({ type: Object })
], PillGroupCarousel.prototype, "pillItems", void 0);
__decorate([
    property({ type: String })
], PillGroupCarousel.prototype, "alignIcon", void 0);
__decorate([
    property({ type: String })
], PillGroupCarousel.prototype, "thumbnail", void 0);
__decorate([
    property({ type: String })
], PillGroupCarousel.prototype, "pillSize", void 0);
__decorate([
    property({ type: Object, required: true })
], PillGroupCarousel.prototype, "theme", void 0);
__decorate([
    property({ type: Number, synchronous: true })
], PillGroupCarousel.prototype, "selectedIndex", void 0);
__decorate([
    property({ type: String })
], PillGroupCarousel.prototype, "ariaLabelCarousel", void 0);
__decorate([
    property({ type: String })
], PillGroupCarousel.prototype, "ariaRoleDescriptionCarousel", void 0);
__decorate([
    property({ type: String })
], PillGroupCarousel.prototype, "ariaLabelCarouselLeftArrow", void 0);
__decorate([
    property({ type: String })
], PillGroupCarousel.prototype, "ariaLabelCarouselRightArrow", void 0);
//# sourceMappingURL=PillGroupCarousel.js.map